export default __webpack_public_path__ + "static/media/survey-response-summary-icon.8e2113cc.svg";